import { ReactNode, createContext, useCallback, useContext, useEffect, useState } from "react";
import ProjectResponseResource from "common/resources/Project/ProjectResponseResource";
import { container } from "tsyringe";
import ProjectService from "services/ProjectService";
import { useProjectId } from "hooks/useProjectId";

const projectService = container.resolve(ProjectService);

export type IProjectTitleContext = {
	project: ProjectResponseResource;
	title: string;
	setTitle: (title: string) => void;
	fetchProject: () => void;
};

type IProps = {
	children: ReactNode;
};

const ProjectTitleContext = createContext<IProjectTitleContext>(undefined!);

export function ProjectTitleProvider(props: IProps) {
	const { projectId } = useProjectId();
	const [project, setProject] = useState<ProjectResponseResource | null>(null);
	const [title, setTitle] = useState<string>("");

	const fetchProject = useCallback(() => {
		projectService.getProjectById(projectId).then(setProject);
	}, [projectId]);

	const init = useCallback(() => {
		projectService.getProjectById(projectId).then((project) => {
			setProject(project);
			setTitle(project.title);
		});
	}, [projectId]);

	useEffect(() => {
		init();
	}, [init]);

	if (!project) return null;

	return <ProjectTitleContext.Provider value={{ project, title, setTitle, fetchProject }}>{props.children}</ProjectTitleContext.Provider>;
}

export const useProjectTitle = () => {
	const context = useContext(ProjectTitleContext);

	if (context === undefined) {
		throw new Error("useProjectTitle must be used within a ProjectTitleProvider");
	}

	return context;
};
